type Params = {
  matchingGamesCount: number;
  moduleNames: string[];
  modulesCount: number;
  hasSingleTagModules: boolean;
};

export const generateTextForDeletingPopup = ({
  matchingGamesCount,
  moduleNames,
  modulesCount,
  hasSingleTagModules,
}: Params) => {
  if (hasSingleTagModules) {
    return (
      <div>
        The tag is used in modules and cannot be deleted. Pls, remove it from
        modules:
        <div style={{ fontWeight: 700 }}>{moduleNames.join(", ")}.</div>
      </div>
    );
  }

  if (matchingGamesCount && !modulesCount) {
    return `This tag is used in ${matchingGamesCount} games. Are you sure you want to delete this tag?`;
  }

  if (matchingGamesCount && modulesCount) {
    return `This tag is used in ${matchingGamesCount} games and ${modulesCount} modules. Are you sure you want to delete this tag?`;
  }

  if (!matchingGamesCount && modulesCount) {
    return `This tag is used in ${modulesCount} modules. Are you sure you want to delete this tag?`;
  }

  return "Are you sure you want to delete this tag?";
};
